<template>
  <td
    colspan="2"
    class="title-section"
    :class="{'title-section-hover': editable}"
  >
    <PricingEditBox
      v-if="showMenu"
      class="editbox"
      @close="showMenu=false"
      @hide="moduleActions('hideModule')"
      @delete="moduleActions('deleteModule')"
      from="module"
    >
    </PricingEditBox>
    <img
      src="/images/ShowColumn.svg"
      class="hidden-row-above"
      @click="unhideModule()"
      v-if="showModuleIcon"
    >
    <img
      src="/images/ShowColumn.svg"
      class="hidden-row-above hidden-module-last"
      v-if="showModuleLastIcon"
      @click="unhideLastModule()"
    >
    <img
      src="/images/Grab.svg"
      class="move-module"
      @dragstart="$emit('dragStarted', moduleKey)"
      @dragend="$emit('dragEnded', moduleKey)"
    />
    <img
      src="/images/More-Vertical.svg"
      class="delete-module delete-module-only"
      @click="showMenu=true"
    />
    <input
      type="text"
      v-model="form.value"
      @blur="handleBlur"
      @keydown="handleKeydown"
      class="edit-module-name"
      ref="input"
      :disabled="!editable"
    >
  </td>
</template>
<script>
import PricingEditBox from './PricingEditBox'
import { mapGetters } from 'vuex';
export default {
  name: 'PricingSheetModuleNameCell',
  data () {
    return {
      showMenu: false,
      form: {
        value: ''
      }
    };
  },
  components: {
    PricingEditBox
  },
  props: {
    name: {
      required: true
    },
    moduleKey: {
      type: Number,
      required: true
    },
    colspan: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleBlur() {
      this.$store.dispatch('changeModuleName', {
        projectid: this.$route.params.projectid,
        moduleid: this.moduleKey,
        name: this.form.value
      })
    },
    handleEscape() {
      this.form.value = this.name
      this.showMenu = false
      this.$refs.input.blur()
    },
    moduleActions(actions) {
      this.$store.dispatch(actions, {
        projectid: this.$route.params.projectid,
        index: this.moduleKey
      }).then(() => {
        this.$emit('updated');
      })
    },
    unhideModule() {
      const modulesToUnhide = []
      for (let i = this.moduleKey - 1; i >= 0; i--) {
        if (!this.currentProjectModules[i].hidden) { break }
        modulesToUnhide.push(i)
      }
      this.$store.dispatch('unhideModule', {
        projectid: this.$route.params.projectid,
        modulesToUnhide: modulesToUnhide
      })
    },
    unhideLastModule() {
      const modulesToUnhide = []
      for (let i = this.moduleKey + 1; i < this.currentProjectModules.length; i++) {
        if (!this.currentProjectModules[i].hidden) { break }
        modulesToUnhide.push(i)
      }
      this.$store.dispatch('unhideModule', {
        projectid: this.$route.params.projectid,
        modulesToUnhide: modulesToUnhide
      })
    },
    handleKeydown(e) {
      e.preventDefault()
      if (e.key === 'Enter') {
        this.$store.dispatch('updateSelectedCell', {
          moduleKey: this.moduleKey,
          comKey: 0
        })
      } else if (e.key === 'Escape') {
        this.handleEscape()
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentProjectModules',
      'showPricesPrices',
      'showPricesHours',
      'userRole'
    ]),
    showModuleIcon() {
      if (this.moduleKey) {
        return this.currentProjectModules[this.moduleKey - 1].hidden
      }
      return false
    },
    showModuleLastIcon () {
      if (this.moduleKey == this.currentProjectModules.length - 1) {
        return false
      }
      return this.currentProjectModules.slice(this.moduleKey + 1).every(c => c.hidden)
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  watch: {
    name(value) {
      this.form.value = this.name
    }
  },
  created () {
    this.form.value = this.name
  }
}
</script>
<style scoped lang="scss">
.title-section {
  background-color: #5558ff!important;
  cursor: pointer;
  text-align: left !important;
  padding-left: 40px;
  padding-right: 25px;
  border: none !important;
  .edit-module-name {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: .71px;
    line-height: 43px;
    background-color: transparent;
    color: white;
    border: none;
    font-family: GG,sans-serif;
    cursor: default;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    width: 100%;
  }
  .edit-module-name:focus {
    border-bottom: 2px solid white;
    line-height: 1em;
    box-sizing: border-box;
    font-weight: 400;
    width: calc(100% - 25px) !important;
  }
  .move-module {
    position: absolute;
    left: 10px;
    width: 24px;
    height: 14px;
    object-fit: scale-down;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: none;
  }
  .delete-module {
    cursor: pointer;
    position: absolute;
    right: 10px;
    width: 20px;
    height: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
  }
}
.title-section-hover:hover {
  .move-module {
    display: block;
  }
  .delete-module {
    display: block;
  }
}
.editbox {
  position: absolute;
  bottom: -60px;
  right: 10px;
  width: 100px;
}
.hidden-row-above {
  /*border-top: 2px solid green;*/
  height: 20px;
  width: 20px;
  position: absolute;
  left: 12px;
  top: -12px;
  transform: rotate(90deg);
  cursor: pointer;
}
.hidden-module-last {
  bottom: 0;
  transform: translateY(50%) rotate(90deg);
  top: unset;
}
</style>
